
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/browse/job-location",
      function () {
        return require("private-next-pages/browse/job-location.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/browse/job-location"])
      });
    }
  